import { FETCH_SHIPMENT_BY_ORDER_SUCCESS, FETCH_SHIPMENT_BY_ORDER_REQUEST, FETCH_SHIPMENT_BY_ORDER_FAILURE, FETCH_SHIPMENT_BY_ORDER_RESET, } from "@/redux/actions";
const initialState = {
    data: null,
    loading: false,
    error: null,
};
const ShipmentByOrderReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_SHIPMENT_BY_ORDER_SUCCESS:
            return Object.assign(Object.assign({}, state), { loading: false, error: null, data: action.payload });
        case FETCH_SHIPMENT_BY_ORDER_REQUEST:
            return Object.assign(Object.assign({}, state), { loading: true, data: null, error: null });
        case FETCH_SHIPMENT_BY_ORDER_FAILURE:
            return Object.assign(Object.assign({}, state), { loading: false, error: action.payload });
        case FETCH_SHIPMENT_BY_ORDER_RESET:
            return Object.assign(Object.assign({}, state), { loading: false, error: null, data: null });
        default:
            return state;
    }
};
export default ShipmentByOrderReducer;
